import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { Link, useParams } from 'react-router-dom';
import { spacing } from '@mui/system';
import { useSnackbar } from 'notistack';
import { Breadcrumbs as MuiBreadcrumbs, Typography, Box, Link as MuiLink } from '@mui/material';
import { PATH_SUPPLIER } from '../../constants';
import SupplierLocations from '../../components/supplier/SupplierFormComponents/SupplierDetails/SupplierLocations';
import { supplierAPI } from '../../services';
import useLogOut from '../../hooks/useLogOut';

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const SupplierLocationPage: React.FC = () => {
  // USE HOOKS
  const { id } = useParams();
  const [errStatus, setErrStatus] = useState(null);
  const { logOut } = useLogOut(errStatus);
  const { enqueueSnackbar } = useSnackbar();
  // FETCH SUPPLIER
  const {
    data: supplierData = {},
    refetch,
    error
  } = supplierAPI.useFetchSupplierLocationQuery({ id }, { refetchOnMountOrArgChange: true });

  // HANDLERS
  const errorHandler = (error: any) => {
    let message: string | any = 'Something went wrong!';
    if (error?.data?.errors) {
      const msg = Object.values(error?.data?.errors).map((item: any) => item?.message || item);
      message = msg[0];
    }
    if (error?.originalStatus === 401) {
      setErrStatus(error?.originalStatus);
      message = 'You are not authorized!';
    }
    enqueueSnackbar(message, {
      variant: 'error'
    });
  };
  // HOOKS
  useEffect(() => {
    if (error) errorHandler(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
  useEffect(() => {
    if (errStatus && typeof logOut === 'function') {
      logOut();
    }
  }, [errStatus, logOut]);

  return (
    <React.Fragment>
      <Box sx={{ mb: 5 }}>
        <Typography variant="h3" gutterBottom>
          Edit Supplier Details
        </Typography>
        <Breadcrumbs>
          <MuiLink component={Link} to={PATH_SUPPLIER.ROOT}>
            Phoenix Waste Collection
          </MuiLink>
          <Typography>Collection Locations</Typography>
        </Breadcrumbs>
      </Box>
      <SupplierLocations
        supplier={{
          counties_ids: [],
          cities_ids: [null],
          ...supplierData
        }}
        refetch={refetch}
      />
    </React.Fragment>
  );
};

export default SupplierLocationPage;
